import type { ReactNode } from 'react';
import { useRouter } from '@tanstack/react-router';

/**
 * A link to a path in the app that a component's config holds as data (a
 * row's page, a related page): a real anchor, so it opens in a new tab as
 * usual, navigating in place on a plain click.
 */
export function ReportLink({
  href,
  className,
  children,
}: {
  href: string;
  className?: string;
  children: ReactNode;
}) {
  const router = useRouter();
  return (
    <a
      href={href}
      className={className}
      onClick={(event) => {
        if (
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        )
          return;
        event.preventDefault();
        void router.navigate({ href });
      }}
    >
      {children}
    </a>
  );
}
